import classNames from "classnames"
import React, { Fragment, useEffect, useState } from "react"
import { connect } from "react-redux"
import { blockUi, unBlockUi } from "../../../actions/actionCreator"
import { FORM_REFS } from "../../../constants"
import { aemHostClient, eapiClient } from '../../../restClient'
import { Translations, isEmptyObject } from "../../../utils"
import DynamicForm from "../../common/Dynamicform/dynamicForm"
import { setDarkTitleBarContent } from '../../layouts/actions/actionCreator'
import DeleteEntityModal from "../Modal"
import { getStatusForPutApi } from "../ProductMapping"
import { setSavedSow, setSowEntities } from "../actions/actionCreator"
import { getTransformedSavedSow } from "../utils"

export const SowCreateEntityPageUrl = "/aemData/formData/json_create-sow-entity-basic-details-page";

const CreateSowEntity = (props = {}) => {
    const initialState = {
        formData: {},
        entityList: props.sowEntities,
        showDeleteModal: false
    }
    const [state, updateState] = useState(initialState)

    const setState = (obj) => {
        if (obj) {
            updateState((prevState) => ({ ...prevState, ...obj }))
        }
    }

    useEffect(() => {
        if ((Array.isArray(state.entityList) && Array.isArray(props.sowEntities) && state.entityList.length !== props.sowEntities.length) || props.isEntitiesDeletedAll) {
            setState({
                entityList: props.isEntitiesDeletedAll ? [] : props.deletedEntities && props.deletedEntities.length ?
                    props.sowEntities.filter(ent => props.deletedEntities.indexOf(ent.id) < 0) : props.sowEntities
            })
        }
    }, [props.sowEntities])

    useEffect(() => {
        aemHostClient("/aemData/formData/json_dark-title-bar")
            .then(({ data, status }) => {
                document.title = `${getTranslation(data.par.static_text_darkTitleBar.createSow)} - ${'HSBC GLCM'}`;
                props.setDarkTitleBarContent(getTranslation(data.par.static_text_darkTitleBar.createSow), true, getTranslation(data.par.static_text_darkTitleBar.sowList), undefined, undefined);
            });
        aemHostClient(SowCreateEntityPageUrl)
            .then(({ data }) => {
                document.title = `${Translations(data.par.page_title_mainTitle.pageHeading, props.lang.currentLang.lang, props.lang.translatedData)} - ${'HSBC GLCM'}`;
                setState({ formJson: data });
            });
    }, [])

    const getTranslation = (word) => {
        return Translations(word, props.lang.currentLang.lang, props.lang.translatedData)
    }

    const onFormSubmit = (event, apiUrl) => {
        event.preventDefault()
        props.setSowEntities(state.entityList)
        if (props.history.location.pathname === "/edit-a-sow/entities") {
            props.blockUi()
            updateSow()
        } else {
            props.history.push("/create-a-sow/product-mapping")
        }
    }

    const onFormCancel = () => {
        props.setSowEntities([])
        props.history.goBack();
    }

    const handleAddEntity = () => {
        const { registeredName, countryOfIncorporation } = state.formData
        if (registeredName && !isEmptyObject(countryOfIncorporation) && state.entityList.findIndex(el => el.registeredName === registeredName && el.countryOfIncorporation.name === countryOfIncorporation.name) < 0) {
            setState({
                entityList: [...state.entityList, { registeredName, countryOfIncorporation }],
                formData: { ...state.formData, registeredName: '', countryOfIncorporation: '' }
            })
        }
    }

    const handleDeleteModalClose = () => {
        setState({ deleteEntityIndex: undefined, showDeleteModal: false })
    }

    const setFieldValidationState = (e, isValid) => {
        return e
    }

    const handleDeleteEntityList = (e, index) => {
        if (index !== undefined) {
            setState({ deleteEntityIndex: index, showDeleteModal: true })
        }
        else if (state.deleteEntityIndex > -1) {
            if (state.entityList && state.entityList[state.deleteEntityIndex] && state.entityList[state.deleteEntityIndex].id) {
                props.updateDeletedEntities(state.entityList[state.deleteEntityIndex].id)
            }
            setState({
                entityList: state.entityList.filter((el, i) => i !== state.deleteEntityIndex),
                showDeleteModal: false,
                deleteEntityIndex: undefined
            })
            const deleteButton = document.querySelectorAll('.delete-btn');
            const inputTextbox = document.querySelector("[name='registeredName']");
            if (deleteButton.length > 1) {
                setTimeout(() => {
                    deleteButton[deleteButton.length - 2].focus();
                }, 0);
            } else if (deleteButton.length <= 1 && inputTextbox) {
                setTimeout(() => {
                    inputTextbox.focus();
                }, 0);
            }
        }
    }

    const handleFormChange = (formData = {}) => {
        const sanitizedFormData = { ...formData }
        Object.keys(sanitizedFormData).map(key => typeof sanitizedFormData[key] === "string" ? sanitizedFormData[key] = sanitizedFormData[key].trim() : '')
        setState({ formData: sanitizedFormData })
    }

    const updateSow = () => {
        const apiUrl = `/sows/${props.sowId}/update-sow`
        eapiClient(apiUrl, {
            method: "PUT",
            data: JSON.stringify(getPayload(updateEntityStatus(state.entityList)))
        }).then(res => {
            const { status, data } = res

            if (data.responseData) {
                eapiClient('/sows/' + props.sowId + '/sow-detail?isStatus=true')
                    .then(({ data, status }) => {
                        props.unBlockUi()
                        if (data.responseData) {
                            setState({
                                entityList: data.responseData.entity
                            })
                            props.setSavedSow(data.responseData);
                            props.setSowEntities([])
                            // props.resetDeletedEntities()
                            props.history.push("/edit-a-sow/product-mapping")
                        }
                    })

            }
        })
    }

    const getPayload = (entities = []) => {
        const payLoad = { entity: [] }
        payLoad.entity = entities.map(entity => {
            const isAgent = Boolean(entity.products && entity.products.agent);
            const payloadObj = {
                ...entity,
                agent: isAgent,
                salesManagerName: isAgent ? entity.salesManagerName : null,
                salesManagerEmail: isAgent ? entity.salesManagerEmail : null,
                globalSalesManagerName: isAgent ? entity.globalSalesManagerName : null,
                globalSalesManagerEmail: isAgent ? entity.globalSalesManagerEmail : null,
                addressLid: isAgent ? entity.addressLid : null
            }
            if (!payloadObj.products) {
                payloadObj.products = {}
            }
            if (payloadObj && payloadObj.products && "agent" in payloadObj.products) {
                delete payloadObj.products.agent
            }
            return payloadObj
        })
        return payLoad
    }

    const updateEntityStatus = (entityList = []) => {
        const newEntityList = entityList.map(entity => ({ ...entity, status: entity.id ? getStatusForPutApi.update : getStatusForPutApi.added }))
        const deletedEntitiesWithStatus = props.deletedEntities.map(id => ({ id, status: getStatusForPutApi.delete }))
        if (deletedEntitiesWithStatus) {
            return [...newEntityList, ...deletedEntitiesWithStatus]
        }
        return newEntityList
    }

    const pageTitle = state.formJson ? state.formJson['par'].page_title_mainTitle : '';
    const containerCss = classNames("create-new-entity");
    const { modal_deleteSowEntityModal: {
        modalTitle = "",
        par1 = "",
        whiteBtn = "Cancel",
        redBtn = "Okay"
    } = {} } = (state.formJson && state.formJson.par) || {}



    return (
        <React.Fragment>
            <div className="create-a-sow-container" >
                <div className={containerCss}>
                    <div className="form-container">
                        <div className="form-title">
                            <h2 className="form-heading">{getTranslation(pageTitle.pageHeading)}</h2>
                            <p className="form-required-desc">{getTranslation(pageTitle.descriptionText)}</p>
                        </div>
                        <CreateEntityForm
                            formJson={state.formJson}
                            createEntityProps={{ ...props }}
                            onFormSubmit={onFormSubmit}
                            onFormCancel={onFormCancel}
                            handleDeleteEntityList={handleDeleteEntityList}
                            handleAddEntity={handleAddEntity}
                            getTranslation={getTranslation}
                            setFieldValidationState={setFieldValidationState}
                            getFormData={handleFormChange}
                            entityList={state.entityList}
                            formData={state.formData}
                            history={props.history}
                            customer={props.customer}
                            isCustAck={props.isCustAck}
                        ></CreateEntityForm>
                    </div>
                </div>
            </div>
            <DeleteEntityModal
                showDialog={state.showDeleteModal}
                toggleDialog={handleDeleteModalClose}
                modalTitle={getTranslation("Are you sure, you want to delete selected entity")}
                par1={"The Entity will be removed from the entities list."}
                cancelBtnText={"Cancel"}
                submitBtnText={"Delete"}
                onCancel={handleDeleteModalClose}
                onSubmit={() => handleDeleteEntityList()}
                properties={{
                    modalTitle: getTranslation(modalTitle),
                    par1: getTranslation(par1),
                    cancelBtnText: getTranslation(whiteBtn),
                    submitBtnText: getTranslation(redBtn)
                }}
            ></DeleteEntityModal>
        </React.Fragment >
    )

}

export const CreateEntityForm = (props = {}) => {

    const { createEntityProps, onFormSubmit, onFormCancel, formJson,
        handleDeleteEntityList, handleAddEntity, entityList = [], getFormData, formData = {}, productType = '', saveButton = false, history,
        addresses, activeEntity, showLoaderOnFetchApiResource = false, customer, isCustAck, isRepeatingComponentWithSameResourceUrl, cachedResourceData } = props

    if (activeEntity) {
        formData.addressLid = activeEntity.agent ? (formData.addressLid ? formData.addressLid : activeEntity.addressLid) : ''
    }
    const properties = {
        formData: { ...formData },
        editType: 'entity',
        pathname: createEntityProps.history.location.pathname,
        mode: createEntityProps.mode,
        productType: productType || "gls-sow-create-entity"
    };

    if (formJson && formJson.par && formJson.par.aemform_) {
        return (
            <Fragment>
                <DynamicForm
                    mode={createEntityProps.mode}
                    properties={properties}
                    url={FORM_REFS[formJson.par.aemform_.formRef]}
                    getFormData={getFormData}
                    onFormSubmit={onFormSubmit}
                    onFormCancel={onFormCancel}
                    disableSubmitOnClick={false}
                    lang={createEntityProps.lang.currentLang.lang}
                    translatedData={createEntityProps.lang.translatedData}
                    flag={createEntityProps.lang.currentLangFlag.flag}
                    productType={productType || "gls-sow-create-entity"}
                    handleAddEntity={handleAddEntity}
                    entityList={entityList}
                    handleDeleteEntityList={handleDeleteEntityList}
                    saveButton={saveButton}
                    history={history}
                    pageState={{}}
                    addressData={addresses}
                    handleRegisteredAddressChange={getFormData}
                    isvisible={activeEntity ? (activeEntity.agent ? false : true) : true}
                    showLoaderOnFetchApiResource={showLoaderOnFetchApiResource}
                    customer={customer}
                    sow
                    isCustAck={isCustAck}
                    isRepeatingComponentWithSameResourceUrl={isRepeatingComponentWithSameResourceUrl}
                    cachedResourceData={cachedResourceData}
                />
            </Fragment >
        );
    } else {
        return null
    }
}

const mapStateToProps = (state, props) => {
    let currentEntity = undefined;
    let newSowEntities = state.sowEntities.entities.length ? state.sowEntities.entities : []
    if (props.location && props.location.state) {
        const { mode, entityId } = props.location.state;
        if (mode === 'edit' && entityId && state.entities[entityId]) {
            currentEntity = state.entities[entityId];
        }
        if (props.location.pathname === "/edit-a-sow/entities") {
            newSowEntities = state.sowEntities && state.sowEntities.savedSow && state.sowEntities.savedSow.entity &&
                state.sowEntities.savedSow.entity.length && state.sowEntities.savedSow.entity.map(singleEntity =>
                    ({ ...singleEntity, products: { ...singleEntity.products, agent: Boolean(singleEntity.agent) } }))
        }
    }
    return {
        currentEntity,
        mode: (state.sowEntities && state.sowEntities.entities && state.sowEntities.length) ||
            (state.sowEntities && state.sowEntities.savedEntities && state.sowEntities.savedEntities.length) ? 'edit' : 'create',
        lang: state.lang,
        sowEntities: state.sowEntities && state.sowEntities.entities && state.sowEntities.entities.length ? state.sowEntities.entities :
            getTransformedSavedSow(props.location.pathname, state.sowEntities && state.sowEntities.savedSow
                && state.sowEntities.savedSow.entity),
        sowId: state.sowEntities.savedSow.sowId
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSowEntities: entities => {
            dispatch(setSowEntities(entities))
        },
        setDarkTitleBarContent: (...args) => {
            dispatch(setDarkTitleBarContent(...args))
        }, blockUi: () => {
            dispatch(blockUi())
        },
        unBlockUi: () => {
            dispatch(unBlockUi())
        },
        setSavedSow: data => {
            dispatch(setSavedSow(data))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateSowEntity)


// WEBPACK FOOTER //
// ./src/components/createASow/CreateEntity/index.js